module.exports = require('../dist/contexts/MarketplaceComparisonTableContext');
